export default __webpack_public_path__ + "static/media/support03.33136d89.png";